import { render, staticRenderFns } from "./chat-normal-user-list.html?vue&type=template&id=5406181a&scoped=true&"
import script from "./chat-normal-user-list.js?vue&type=script&lang=js&"
export * from "./chat-normal-user-list.js?vue&type=script&lang=js&"
import style0 from "./chat-normal-user-list.scss?vue&type=style&index=0&id=5406181a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5406181a",
  null
  
)

export default component.exports